import React from "react"
import { useSpring, animated } from "@react-spring/web"
import CirclePath from "./CirclePath"

const CP = animated(CirclePath)

const AnimatedCirclePath = ({ percentage, ...rest }) => {
  const progressSpring = useSpring({
    percentage: percentage,
    from: { percentage: 0 },
  })

  const innerProps = { percentage: progressSpring.percentage, ...rest }

  return <CP {...innerProps} />
}

export default AnimatedCirclePath
